module.exports = __webpack_public_path__ + "assets/img/dzh-16.35e59d5f.jpg";